//Clase de la aplicacion BextDocUI
//Autor:Marlon Granda-Fecha:25/21/2019 - Mail:mar_gran2003@yahoo.com.ar
//Empresa:Marlon Granda

import { Component, ViewChild, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Paginas, ControllerMethods, DataTableAjaxOrderTypes, TypesUseForm, ControlActions } from '../../../models/general.enum';
import { Utilities } from '../../../helpers/utilities';
import { ModalNotifyComponent, ModalNotifyTypes } from '../../../components/modal-notify/modal-notify.component';
import { BaseServiceService } from '../../../services/base-service.service'
import { BaseCrud } from '../../../bussines/base-crud';
import { GeneralFormComponent } from '../../controls/general-form/general-form.component';
import { HelperImages } from 'src/app/helpers/helper-images';
import { HelperRules } from 'src/app/helpers/helper-rules';
import { HelperActions } from 'src/app/helpers/helper-actions';
import { UserSettingsModelComponent } from '../../rule-engine/info-project/user-settings-model/user-settings-model.component';

@Component({
	selector: 'app-rusuario',
	templateUrl: './rusuario.component.html',
	styleUrls: ['./rusuario.component.css']
})
export class RUsuarioComponent extends GeneralFormComponent implements OnInit, AfterViewInit {
	// @ViewChild('userModelComponent', { static: false }) userModelComponent: UserModelComponent;
	userSettingsModelComponent: UserSettingsModelComponent;
	constructor(public baseService: BaseServiceService, public utility: Utilities,
		public helperImages: HelperImages,
		public helperRules: HelperRules,
		public helperActions: HelperActions) {

		super(baseService, utility, helperImages, helperRules, helperActions);
	}
	public AddComponentInstanceHandler(event) {
		debugger;
		if (event instanceof UserSettingsModelComponent) {
			this.userSettingsModelComponent = event;
		}
		else {
			super.AddComponentInstanceHandler(event);
		}
	}

	// ngAfterViewInit() {
	// 	debugger
	// 	this.userModel.Nueva();
	// }

	public OnInitEnd() {
		this.preSaveEmitter.subscribe(model => {
			debugger;
			if (model.modelo.modelo.ConfigFirma != null && typeof (model.modelo.modelo.ConfigFirma) === "object")
				model.modelo.modelo.ConfigFirma = JSON.stringify(model.modelo.modelo.ConfigFirma);
			this.modelo.modelo.Configuracion = this.userSettingsModelComponent.GetConfiguracion();

		});
		this.preEditEmitter.subscribe(data => {
			debugger;
			if (data.modelo.modelo.ConfigFirma != null && data.modelo.modelo.ConfigFirma != "" && typeof (data.modelo.modelo.ConfigFirma) === "string")
				data.modelo.modelo.ConfigFirma = JSON.parse(data.modelo.modelo.ConfigFirma);
			this.userSettingsModelComponent.SetModelo(data.modelo);
		});

		if (!this.Pagina.IsCustom) {
		

			this.postSaveEmitter.subscribe(data => {
				if (this.componentsContainer.FileBox && (data.modelo.modelo.Identificacion != null && data.modelo.modelo.Identificacion != "")) {
					data.modelo.modelo = data.data.data;
					this.componentsContainer.FileBox.sendCurrentModel = true;
					this.componentsContainer.FileBox.modelo = data.modelo;

					this.componentsContainer.FileBox.uploadFiles();
				}
					this.componentsContainer.FileBox.selectedFiles=[];
					this.componentsContainer.FileBox.hideSelectBtn=false;
					this.userSettingsModelComponent.Limpiar();
			});
		}

	}
}
